import {api} from '../middleware/api';

// Define endpoints using injectApi pattern
export const usersApi = api
  .enhanceEndpoints({addTagTypes: ['User']})
  .injectEndpoints({
    endpoints: builder => ({
      getConn: builder.query<any, any>({
        query: () => ``,
        providesTags: ['User'],
      }),
      getUsers: builder.query<auser[], string>({
        query: cid => `users/${cid}`,
        providesTags: ['User'],
      }),
      getUser: builder.query<auser, string>({
        query: id => `users/byid/${id}`,
      }),
      getToken: builder.query<any, any>({
        query: ({cm_code, us_id, us_name}) => ({
          url: `users/gettoken/`,
          method: 'POST',
          body: {cm_code, us_id, us_name},
        }),
      }),
      signIn: builder.mutation({
        query: user => ({
          url: `users/signin/`,
          method: 'POST',
          body: user,
        }),
      }),
      guestSignIn: builder.mutation({
        query: user => ({
          url: `users/guestsignin/`,
          method: 'POST',
          body: user,
        }),
      }),
      roomSignIn: builder.mutation({
        query: user => ({
          url: `users/roomsignin/`,
          method: 'POST',
          body: user,
        }),
      }),
      signOut: builder.mutation({
        query: () => ({
          url: `users/signout/`,
          method: 'POST',
        }),
      }),
      insertUser: builder.mutation({
        query: user => ({
          url: `users/`,
          method: 'POST',
          body: user,
        }),
        invalidatesTags: ['User'],
      }),
      updateUser: builder.mutation({
        query: user => ({
          url: `users/`,
          method: 'PUT',
          body: user,
        }),
        invalidatesTags: ['User'],
      }),
      updateUserPwd: builder.mutation({
        query: user => ({
          url: `users/pwd`,
          method: 'PUT',
          body: user,
        }),
        invalidatesTags: ['User'],
      }),
      updateUserPasswd: builder.mutation({
        query: user => ({
          url: `users/passwd`,
          method: 'PUT',
          body: user,
        }),
        invalidatesTags: ['User'],
      }),
      deleteUser: builder.mutation({
        query: user => ({
          url: `users/${user.us_id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['User'],
      }),
    }),
    overrideExisting: true,
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLazyGetConnQuery,
  useGetUsersQuery,
  useGetUserQuery,
  useGetTokenQuery,
  useLazyGetTokenQuery,
  useSignInMutation,
  useGuestSignInMutation,
  useRoomSignInMutation,
  useSignOutMutation,
  useInsertUserMutation,
  useUpdateUserMutation,
  useUpdateUserPwdMutation,
  useUpdateUserPasswdMutation,
  useDeleteUserMutation,
} = usersApi;

